window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),
  }
};

theme.init = function () {
  theme.cacheSelectors();
};

$(theme.init)

$(document).ready(function () {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
    if ($('#agree').is(':checked')) {
      valor = document.getElementById("cuit").value;
      if (valor.length < 7 || valor.length > 8) {
        alert("Ingrese un D.N.I válido - Debe contener entre 7 y 8 caracteres");
        return false;
      } else {
        $(this).submit();
      }
    }
    else {
      alert("Debes estar de acuerdo con los términos y condiciones.");
      return false; 
    }

  });

});

document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    new Swiper('[js-cus-product-list-slider]', {
      spaceBetween: 16,
      navigation: {
        nextEl: ".next-arrow",
        prevEl: ".prev-arrow"
      },
      breakpoints: {

        0: { slidesPerView: 1.2 },


        767: { slidesPerView: 2 },


        990: { slidesPerView: 3 },


        1280: { slidesPerView: 4 }
      }
    });
  }
});




document.addEventListener('DOMContentLoaded', () => {
  const selectors = {
    productCard: '[js-cus-product-wrapper]',
    productJson: '[js-cus-product-json-data]',
    checkedOption: '[js-cus-option]:checked',
    optionInput: '[js-cus-option]',
    addToBagBtn: '[js-cus-product-add-to-bag-btn]',
    addToCartBtn: '[js-cus-product-atc-btn]',
    colorSwatch: '[js-swatch-color-img]',
    sizeOption: '[js-swatch-size-option]',
    sizeWrapper: '[js-cus-option-size-wrapper]',
    productImage: '[js-cus-product-image]',
    productBackImage: '[js-cus-product-back-img]',
    salePrice: '[js-sale-price]',
    comparePrice: '[js-compare-price]'
  };

  function getProductJson(parent) {
    const el = parent.querySelector(selectors.productJson);
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error('Invalid product JSON:', error);
      return null;
    }
  }

  function getSelectedInputs(parent) {
    return [...parent.querySelectorAll(selectors.checkedOption)];
  }

  function getSelectedColorInput(parent) {
    return parent.querySelector(`${selectors.colorSwatch} ${selectors.optionInput}:checked`);
  }

  function getSelectedSizeInput(parent) {
    return parent.querySelector(`${selectors.sizeOption} ${selectors.optionInput}:checked`);
  }

  function getSelectedColorValue(parent) {
    const input = getSelectedColorInput(parent);
    return input ? input.value : '';
  }

  function getSelectedSizeValue(parent) {
    const input = getSelectedSizeInput(parent);
    return input ? input.value : '';
  }

  function getFinalOptionTitle(parent) {
    const selectedInputs = getSelectedInputs(parent);
    if (selectedInputs.length < 2) return '';

    const firstOption = selectedInputs[0].value;
    const secondOption = selectedInputs[1].value;
    const sizePosition = selectedInputs[0].dataset.optionIndex;

    return sizePosition == 1
      ? `${firstOption} / ${secondOption}`
      : `${secondOption} / ${firstOption}`;
  }

  function findSelectedVariant(parent, variants) {
    const finalOption = getFinalOptionTitle(parent);
    if (!finalOption) return null;

    return variants.find(variant => variant.title === finalOption) || null;
  }

  function findVariantForSelectedColor(parent, variants) {
    const selectedColor = getSelectedColorValue(parent);
    if (!selectedColor) return null;

    const exactVariant = findSelectedVariant(parent, variants);
    if (exactVariant) return exactVariant;

    return (
      variants.find(
        variant =>
          variant.available &&
          (variant.option1 === selectedColor || variant.option2 === selectedColor)
      ) ||
      variants.find(
        variant =>
          variant.option1 === selectedColor || variant.option2 === selectedColor
      ) ||
      null
    );
  }

  function formatMoney(cents) {
    return Utils.formatMoney(parseFloat(cents) / 100);
  }

  function updatePriceUI(parent, variant) {
    if (!variant) return;

    const salePriceEl = parent.querySelector(selectors.salePrice);
    const comparePriceEl = parent.querySelector(selectors.comparePrice);

    if (salePriceEl) {
      salePriceEl.innerHTML = `<span>${formatMoney(variant.price)}</span>`;
    }

    if (comparePriceEl) {
      comparePriceEl.innerHTML = variant.compare_at_price
        ? `<span>${formatMoney(variant.compare_at_price)}</span>`
        : '';
    }
  }

  function updateDiscountTag(parent, variant, productJson) {
    if (!variant || !productJson) return;

    updatePriceUI(parent, variant);

    let salePercent = 0;
    let onSale = false;

    if (variant.compare_at_price) {
      const selectedVariantPrice = parseFloat(variant.price) / 100;
      const selectedVariantComparePrice = parseFloat(variant.compare_at_price) / 100;

      salePercent = Math.round(
        ((selectedVariantComparePrice - selectedVariantPrice) * 100) / selectedVariantComparePrice
      );

      onSale = true;
    }

    const webSpecialTag = productJson.tags.some(tag => tag.toLowerCase() === 'web-specials');
    const nuevosTag = productJson.tags.some(tag => tag === 'Nuevos');
    const ddmTag = productJson.tags.some(tag => tag === 'DDM24');

    const publishedDate = new Date(productJson.published_at);
    const today = new Date();
    const diffDays = Math.round((today.getTime() - publishedDate.getTime()) / (1000 * 3600 * 24));

    const tagWrapper = parent.querySelector('.product-tag_wrap');
    if (!tagWrapper) return;

    if (onSale && ddmTag) {
      tagWrapper.innerHTML = `<span class="ddm cs-product-tag cs-web-specials">${salePercent}% OFF</span>`;
    } else if (onSale) {
      tagWrapper.innerHTML = `<span class="os cs-product-tag cs-web-specials">${salePercent}% OFF</span>`;
    } 
    else if (onSale && webSpecialTag) {
      tabWrapper.innerHTML = '<span class="ws cs-product-tag cs-web-specials">Web Special</span>';
    }

    else if (onSale && !webSpecialTag) {
      tabWrapper.innerHTML = `<span class="nws cs-product-tag cs-web-specials"> ${salePercent}% OFF</span>`;
    }
     else if (nuevosTag && diffDays <= 30) {
      tagWrapper.innerHTML = '<span class="cs-product-tag cs-nuevos">Nuevo</span>';
    } else {
      tagWrapper.innerHTML = '';
    }
  }

  function updateProductImages(parent, productJson, selectedColor) {
    if (!productJson || !productJson.available || !selectedColor) return;

    const matchedImages = productJson.media.filter(media => {
      return (
        media?.alt?.includes(selectedColor) &&
        (media.alt.includes('Back') || media.alt.includes('Front'))
      );
    });

    const frontImage = parent.querySelector(selectors.productImage);
    const backImage = parent.querySelector(selectors.productBackImage);

    if (!frontImage || !backImage || !matchedImages.length) return;

    if (matchedImages[0]) {
      frontImage.setAttribute('src', matchedImages[0].src);
      frontImage.setAttribute('srcAlt', matchedImages[0].alt);
    }

    if (matchedImages[1]) {
      backImage.setAttribute('src', matchedImages[1].src);
      backImage.setAttribute('backAlt', matchedImages[1].alt);
    } else if (matchedImages[0]) {
      backImage.setAttribute('src', matchedImages[0].src);
      backImage.setAttribute('backAlt', matchedImages[0].alt);
    }
  }

  function clearSizeSelection(parent) {
    parent.querySelectorAll(`${selectors.sizeOption} ${selectors.optionInput}`).forEach(input => {
      input.checked = false;
    });

    parent.querySelectorAll(selectors.sizeOption).forEach(option => {
      option.classList.remove('active');
    });

    updateCartButtonState(parent);
  }

  function updateCartButtonState(parent) {
    const addToCartButton = parent.querySelector(selectors.addToCartBtn);
    if (!addToCartButton) return;

    const selectedSize = getSelectedSizeInput(parent);

    if (!selectedSize) {
      addToCartButton.textContent = 'Selecciona un talle';
      addToCartButton.disabled = true;
      return;
    }

    const sizeOption = selectedSize.closest(selectors.sizeOption);
    if (!sizeOption) return;

    if (sizeOption.classList.contains('outofstock')) {
      addToCartButton.textContent = 'No disponible';
      addToCartButton.disabled = true;
    } else {
      addToCartButton.textContent = 'Agregar al carrito';
      addToCartButton.disabled = false;
    }
  }

  function updateSizeAvailability(parent) {
    const productJson = getProductJson(parent);
    if (!productJson) return;

    const selectedColor = getSelectedColorValue(parent);
    if (!selectedColor) return;

    const variants = productJson.variants;
    const sizeOptions = [...parent.querySelectorAll(selectors.sizeOption)];
    const availableSizes = new Set();

    sizeOptions.forEach(sizeOption => {
      const sizeValue = sizeOption.dataset.optionValue;
      const title = `${selectedColor} / ${sizeValue}`;
      const matchedVariant = variants.find(variant => variant.title === title);
      const input = sizeOption.querySelector(selectors.optionInput);

      if (matchedVariant) {
        availableSizes.add(sizeValue);

        if (matchedVariant.available) {
          sizeOption.classList.remove('outofstock');
        } else {
          sizeOption.classList.add('outofstock');
        }

        if (input) input.disabled = false;
      } else {
        sizeOption.classList.remove('outofstock');
        if (input) {
          input.checked = false;
          input.disabled = false;
        }
      }
    });

    sizeOptions.forEach(sizeOption => {
      const sizeValue = sizeOption.dataset.optionValue;
      const isAvailableForColor = availableSizes.has(sizeValue);

      sizeOption.style.display = isAvailableForColor ? 'block' : 'none';
      sizeOption.classList.toggle('hide', !isAvailableForColor);

      const input = sizeOption.querySelector(selectors.optionInput);
      if (input && !isAvailableForColor) {
        input.checked = false;
      }
    });
  }

  function updateCardForCurrentSelection(parent) {
    const productJson = getProductJson(parent);
    if (!productJson) return;

    const selectedColor = getSelectedColorValue(parent);
    if (selectedColor) {
      updateProductImages(parent, productJson, selectedColor);
    }

    const selectedVariant =
      findSelectedVariant(parent, productJson.variants) ||
      findVariantForSelectedColor(parent, productJson.variants);

    if (selectedVariant) {
      updateDiscountTag(parent, selectedVariant, productJson);
    }
  }

  function handleSizeChange(sizeOption) {
    const parent = sizeOption.closest(selectors.productCard);
    if (!parent) return;

    parent.querySelectorAll(`${selectors.sizeOption} ${selectors.optionInput}`).forEach(input => {
      input.checked = false;
    });

    parent.querySelectorAll(selectors.sizeOption).forEach(option => {
      option.classList.remove('active');
    });

    const input = sizeOption.querySelector(selectors.optionInput);
    if (input) input.checked = true;

    sizeOption.classList.add('active');

    updateCartButtonState(parent);
    updateCardForCurrentSelection(parent);
  }

  function openSizeState(productCard) {
    document.querySelectorAll(selectors.productCard).forEach(card => {
      if (card !== productCard && card.dataset.sizeOpened === 'true') {
        resetSizeState(card);
      }
    });

    productCard.dataset.sizeOpened = 'true';

    const addToBagBtn = productCard.querySelector(selectors.addToBagBtn);
    const addToCartBtn = productCard.querySelector(selectors.addToCartBtn);
    const sizeWrapper = productCard.querySelector(selectors.sizeWrapper);

    if (addToBagBtn) addToBagBtn.classList.add('hidden');
    if (addToCartBtn) addToCartBtn.classList.add('hidden');
    if (sizeWrapper) sizeWrapper.classList.remove('hidden');
  }

  function resetSizeState(productCard) {
    productCard.dataset.sizeOpened = 'false';

    const addToBagBtn = productCard.querySelector(selectors.addToBagBtn);
    const addToCartBtn = productCard.querySelector(selectors.addToCartBtn);
    const sizeWrapper = productCard.querySelector(selectors.sizeWrapper);

    if (addToBagBtn) addToBagBtn.classList.remove('hidden');
    if (addToCartBtn) addToCartBtn.classList.add('hidden');
    if (sizeWrapper) sizeWrapper.classList.add('hidden');

    clearSizeSelection(productCard);
  }

  function syncCardState(productCard) {
    const isOpened = productCard.dataset.sizeOpened === 'true';

    const addToBagBtn = productCard.querySelector(selectors.addToBagBtn);
    const addToCartBtn = productCard.querySelector(selectors.addToCartBtn);
    const sizeWrapper = productCard.querySelector(selectors.sizeWrapper);

    if (isOpened) {
      if (addToBagBtn) addToBagBtn.classList.add('hidden');
      if (addToCartBtn) addToCartBtn.classList.add('hidden');
      if (sizeWrapper) sizeWrapper.classList.remove('hidden');
    } else {
      if (addToBagBtn) addToBagBtn.classList.remove('hidden');
      if (addToCartBtn) addToCartBtn.classList.add('hidden');
      if (sizeWrapper) sizeWrapper.classList.add('hidden');
    }
  }

  function renderOptions(selectedOptions) {
    const optionValue = selectedOptions.split('/');
    const rawColor = optionValue[0] ? optionValue[0].trim() : '';
    const sizeValue = optionValue[1] ? optionValue[1].trim() : '';
    const translatedColor = window.translateColor ? window.translateColor(rawColor) : rawColor;

    return `
      <p class="variants">
        Color: <span>${translatedColor}</span>
        <span class="divider">|</span>
      </p>
      <p class="variants ${sizeValue}">
        Talle: <span>${sizeValue}</span>
        <span class="divider">|</span>
      </p>
    `;
  }

  function renderPopup(productTitle, variant, variantPrice, selectedOptions, imgLink) {
    $('body').append(`
      <div class="main-pdp-popup" data-toggle="modal" js-pdp-popup>
        <div class="add-to-cart-notification">
          <div class="loader">
            <svg class="patagonia-loading" viewBox="0 0 262 50" aria-labelledby="picon--patagonia-loading-desc picon--patagonia-loading-title" id="icon--patagonia-loading" xmlns="http://www.w3.org/2000/svg">
              <title id="picon--patagonia-loading-title">Loading ...</title>
              <desc id="picon--patagonia-loading-desc">Patagonia Loading Icon</desc>
              <path class="mountains" d="M5 44.8l1.8-.7c2.1-.8 4.2-1.6 6.2-2.4.9-.4 1.6-.9 2.2-1.6 1-1.1 1.9-2.2 2.8-3.4.8-1 1.5-2 2.2-3 1.1-1.5 2.3-2.9 3.6-4.2.8-.9 1.7-1.8 2.6-2.7.7-.7 1.2-.6 1.8.1.9 1 1.6 2.2 2.4 3.3 1.2 1.6 2.5 3.1 3.9 4.5.9.8 1.9 1.5 2.9 2.1 2.7 1.5 5.5 2.7 8.4 4 1.4.6 2.9 1.3 4.2 2.1 1 .7 2.2 1.2 3.4 1.5 1.4.3 2.8-.2 3.6-1.3 1.7-2.2 3.3-4.4 5.1-6.6.9-1.2 2-2.3 3-3.5.2-.2.4-.5.7-.7.6-.7 1.7-.7 2.4-.1l.2.2c1.6 1.8 3.3 3.4 5.2 4.9 1.1 1 2.2 2 3.3 2.9.4.4.9.8 1.4 1.1.8.8 2 .8 2.8.1.5-.4 1-.9 1.3-1.4.6-1 1.1-2 1.7-3 .8-1.5 1.7-3 2.6-4.5.3-.5.6-1 1-1.4 1.6-2.2 3.6-4 5.9-5.6.6-.7 1.7-.7 2.3-.1l.1.1c.4.3.8.6 1.1 1 1.2 1.4 2.3 2.9 3.2 4.5.9 1.5 2.2 2.7 3.8 3.4l9.3 4.6.6.3c.6.3.8.3 1.1-.2 1.5-1.8 3.4-3.1 5-4.7.1-.1.2-.2.4-.3.2-.2.5-.2.8-.1.7.3 1.3.5 2 .8 1 .5 2 1 2.9 1.5.6.4 1.4.4 2 0 .6-.4 1.2-.8 1.7-1.3 1.5-1.4 2.9-2.7 4.3-4.2 1.9-1.9 3.7-4 5.6-5.9 1.7-1.7 3-3.7 4.1-5.8.4-.9 1-1.7 1.7-2.4 3.7-4 7.5-8 11.4-11.9.3-.4.9-.5 1.3-.2 1.2.6 2.4 1.2 3.5 2 1.4 1 2 2.5 2.5 4.1.6 1.8 1 3.6 1.3 5.5.5 2.5 1 4.9 1.6 7.3 0 .2.1.3.1.5.3 1.1.3 1.1 1.6 1 1.4-.1 2.7-.5 3.9-1.1.6-.3 1.2-.5 1.8-.6.7-.1 1.4.2 1.8.8.8 1.1 1.5 2.2 2.2 3.4.6 1.1 1.2 2.3 1.8 3.5 1.3 2.9 2.4 5.9 3.4 9l.3.9c.4 1 .6 1.2 1.7 1.1 1-.1 1.9-.3 2.8-.8 1.2-.7 2.4-1.3 3.5-2 1-.6 2-1.1 3-1.6 2-.8 4-1.7 6-2.5.6-.3 1.3-.3 1.9 0 1.6.7 3.2 1.3 4.8 2.1.6.3 1.3.3 1.8 0 .4-.2.9-.4 1.4-.6l7.4-3.3c.3-.1.6-.2.9-.4.4-.2.9-.1 1.1.3.7.8 1.4 1.7 2.1 2.5 1.1 1.2 2.6 2.2 4.1 2.8.8.3 1.6.3 2.4-.1 2.6-1 5.2-2.2 7.7-3.6.9-.6 2.1-.5 3 .2 3.2 2.2 6.6 4.1 9.9 6.2 2 1.2 4 2.4 6 3.5l1.2.7"></path>
              <path class="mountains-animated" d="M5 44.8l1.8-.7c2.1-.8 4.2-1.6 6.2-2.4.9-.4 1.6-.9 2.2-1.6 1-1.1 1.9-2.2 2.8-3.4.8-1 1.5-2 2.2-3 1.1-1.5 2.3-2.9 3.6-4.2.8-.9 1.7-1.8 2.6-2.7.7-.7 1.2-.6 1.8.1.9 1 1.6 2.2 2.4 3.3 1.2 1.6 2.5 3.1 3.9 4.5.9.8 1.9 1.5 2.9 2.1 2.7 1.5 5.5 2.7 8.4 4 1.4.6 2.9 1.3 4.2 2.1 1 .7 2.2 1.2 3.4 1.5 1.4.3 2.8-.2 3.6-1.3 1.7-2.2 3.3-4.4 5.1-6.6.9-1.2 2-2.3 3-3.5.2-.2.4-.5.7-.7.6-.7 1.7-.7 2.4-.1l.2.2c1.6 1.8 3.3 3.4 5.2 4.9 1.1 1 2.2 2 3.3 2.9.4.4.9.8 1.4 1.1.8.8 2 .8 2.8.1.5-.4 1-.9 1.3-1.4.6-1 1.1-2 1.7-3 .8-1.5 1.7-3 2.6-4.5.3-.5.6-1 1-1.4 1.6-2.2 3.6-4 5.9-5.6.6-.7 1.7-.7 2.3-.1l.1.1c.4.3.8.6 1.1 1 1.2 1.4 2.3 2.9 3.2 4.5.9 1.5 2.2 2.7 3.8 3.4l9.3 4.6.6.3c.6.3.8.3 1.1-.2 1.5-1.8 3.4-3.1 5-4.7.1-.1.2-.2.4-.3.2-.2.5-.2.8-.1.7.3 1.3.5 2 .8 1 .5 2 1 2.9 1.5.6.4 1.4.4 2 0 .6-.4 1.2-.8 1.7-1.3 1.5-1.4 2.9-2.7 4.3-4.2 1.9-1.9 3.7-4 5.6-5.9 1.7-1.7 3-3.7 4.1-5.8.4-.9 1-1.7 1.7-2.4 3.7-4 7.5-8 11.4-11.9.3-.4.9-.5 1.3-.2 1.2.6 2.4 1.2 3.5 2 1.4 1 2 2.5 2.5 4.1.6 1.8 1 3.6 1.3 5.5.5 2.5 1 4.9 1.6 7.3 0 .2.1.3.1.5.3 1.1.3 1.1 1.6 1 1.4-.1 2.7-.5 3.9-1.1.6-.3 1.2-.5 1.8-.6.7-.1 1.4.2 1.8.8.8 1.1 1.5 2.2 2.2 3.4.6 1.1 1.2 2.3 1.8 3.5 1.3 2.9 2.4 5.9 3.4 9l.3.9c.4 1 .6 1.2 1.7 1.1 1-.1 1.9-.3 2.8-.8 1.2-.7 2.4-1.3 3.5-2 1-.6 2-1.1 3-1.6 2-.8 4-1.7 6-2.5.6-.3 1.3-.3 1.9 0 1.6.7 3.2 1.3 4.8 2.1.6.3 1.3.3 1.8 0 .4-.2.9-.4 1.4-.6l7.4-3.3c.3-.1.6-.2.9-.4.4-.2.9-.1 1.1.3.7.8 1.4 1.7 2.1 2.5 1.1 1.2 2.6 2.2 4.1 2.8.8.3 1.6.3 2.4-.1 2.6-1 5.2-2.2 7.7-3.6.9-.6 2.1-.5 3 .2 3.2 2.2 6.6 4.1 9.9 6.2 2 1.2 4 2.4 6 3.5l1.2.7"></path>
            </svg>
          </div>
          <div class="popup">
            <div class="cross-svg" js-close-btn>
              <svg width="10" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#A1A1A1" fill-rule="nonzero"></path></svg>
            </div>
            <div>
              <div class="container-main-title">
                <h3 class="main-title">Producto agregado al carrito</h3>
              </div>
              <div class="adtc-product-details">
                <div class="image">
                  <img
                    src="${imgLink}"
                    width="50px"
                    height="100px"
                    alt="${variant.featured_media?.alt || productTitle}"
                  />
                </div>
                <div class="adtc-product-details-inner">
                  <h2 class="product-title" cart-popup-title>${productTitle}</h2>
                  <div class="options mt-lg-5">
                    ${renderOptions(selectedOptions)}
                    <p class="variants">Precio: <span class="price">${Utils.formatMoney(variantPrice / 100)}</span></p>
                  </div>
                </div>
              </div>
              <div class="buttons text-center mt-lg-5">
                <a href="/cart" class="btn btn-lg btn-dark mb-4">Ir al Carrito</a>
                <a class="btn btn-lg btn-orange" js-close-btn>Seguir comprando</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    `);
  }

  function initProductModal(productTitle, variant, variantPrice, selectedOptions, imgLink) {
    renderPopup(productTitle, variant, variantPrice, selectedOptions, imgLink);

    document.querySelectorAll('[js-close-btn]').forEach(closeBtn => {
      closeBtn.addEventListener('click', function () {
        const popup = document.querySelector('[js-pdp-popup]');
        if (popup) popup.remove();
      });
    });

    const loader = document.querySelector('.loader');
    const mainpdp = document.querySelector('.main-pdp-popup .popup');

    setTimeout(() => {
      if (loader) loader.style.display = 'none';
      if (mainpdp) mainpdp.style.opacity = 1;
    }, 2000);
  }

  function addSelectedVariantToCart(parent) {
    if (!parent || parent.dataset.addingToCart === 'true') return;

    const productJson = getProductJson(parent);
    if (!productJson) return;

    const selectedVariant = findSelectedVariant(parent, productJson.variants);
    if (!selectedVariant || !selectedVariant.available) return;

    const productTitle = parent.dataset.productTitle || '';
    const selectedImage = parent.querySelector('.product-featured-media img');
    const selectedImageSrc = selectedImage ? selectedImage.getAttribute('src') : '';
    const finalOption = getFinalOptionTitle(parent);

    parent.dataset.addingToCart = 'true';

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: selectedVariant.id
      },
      dataType: 'json',
      success: function (data) {
        initProductModal(productTitle, selectedVariant, data.price, finalOption, selectedImageSrc);
      },
      complete: function () {
        parent.dataset.addingToCart = 'false';
      }
    });
  }

  function handleSwatchOverflow(productCard) {
    const swatchWrapper = productCard.querySelector('.product-options');
    if (!swatchWrapper) return;

    const swatches = [...swatchWrapper.querySelectorAll(`${selectors.colorSwatch}:not(.hide)`)];
    if (!swatches.length) return;

    const isMobile = window.innerWidth <= 768;
    const maxVisible = isMobile ? 4 : 5;

    swatchWrapper.querySelectorAll('.swatch-more').forEach(el => el.remove());

    swatches.forEach(swatch => {
      swatch.style.display = '';
    });

    swatches.forEach((swatch, index) => {
      if (index >= maxVisible) {
        swatch.style.display = 'none';
      }
    });

    if (swatches.length > maxVisible) {
      const remaining = swatches.length - maxVisible;
      const moreBtn = document.createElement('span');

      moreBtn.className = 'swatch-more';
      moreBtn.textContent = `+${remaining}`;
      moreBtn.style.cursor = 'pointer';
      moreBtn.style.fontWeight = '700';

      const firstSwatch = swatches[0];
      const variantId = firstSwatch?.dataset.variantId;
      const productLink = productCard.querySelector('a[href]');
      const href = productLink ? productLink.getAttribute('href').split('?')[0] : '#';

      moreBtn.addEventListener('click', () => {
        const targetUrl = variantId ? `${href}?variant=${variantId}` : href;
        window.location.href = targetUrl;
      });

      swatchWrapper.appendChild(moreBtn);
    }
  }

  function setupSwatchVisibility(productCard) {
    const productJson = getProductJson(productCard);
    if (!productJson) return;

    const groupedStockStatus = {};

    productJson.variants.forEach(variant => {
      const color = variant.option1;
      if (!groupedStockStatus[color]) {
        groupedStockStatus[color] = [];
      }
      groupedStockStatus[color].push(variant.available);
    });

    Object.keys(groupedStockStatus).forEach(color => {
      if (!groupedStockStatus[color].includes(true)) {
        const swatches = productCard.querySelectorAll(`[data-option-color-name="${color}"]`);
        if (swatches[0]) swatches[0].classList.add('hide');
      }
    });
  }

  function selectFirstAvailableColor(productCard) {
    const colorOptions = [...productCard.querySelectorAll(selectors.colorSwatch)];
    const availableColors = colorOptions.filter(color => !color.classList.contains('hide'));
    if (!availableColors.length) return;

    const firstColorInput = availableColors[0].querySelector(selectors.optionInput);
    if (!firstColorInput) return;

    firstColorInput.checked = true;
    firstColorInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onColorChange(productCard) {
    updateSizeAvailability(productCard);
    clearSizeSelection(productCard);
    updateCardForCurrentSelection(productCard);
    handleSwatchOverflow(productCard);
  }

  function bindProductCard(productCard) {
    productCard.dataset.sizeOpened = 'false';

    setupSwatchVisibility(productCard);

    productCard.querySelectorAll(selectors.colorSwatch).forEach(color => {
      color.addEventListener('change', () => {
        setTimeout(() => onColorChange(productCard), 50);
      });
    });

    productCard.querySelectorAll(selectors.sizeOption).forEach(sizeOption => {
      sizeOption.addEventListener('click', () => {
        const isHidden =
          sizeOption.style.display === 'none' || sizeOption.classList.contains('hide');

        if (isHidden) return;

        handleSizeChange(sizeOption);

        if (!sizeOption.classList.contains('outofstock')) {
          addSelectedVariantToCart(productCard);
        }
      });
    });

    productCard.addEventListener('mouseenter', () => {
      syncCardState(productCard);
    });

    selectFirstAvailableColor(productCard);

    setTimeout(() => {
      updateSizeAvailability(productCard);
      updateCardForCurrentSelection(productCard);
      handleSwatchOverflow(productCard);
    }, 100);
  }

  document.querySelectorAll(selectors.productCard).forEach(bindProductCard);

  document.addEventListener('click', event => {
    document.querySelectorAll(selectors.addToBagBtn).forEach(btn => {
      if (!btn.contains(event.target)) return;

      const parent = btn.closest(selectors.productCard);
      if (!parent) return;

      openSizeState(parent);
      updateSizeAvailability(parent);
      clearSizeSelection(parent);
      updateCardForCurrentSelection(parent);
    });

    document.querySelectorAll('[js-close-btn]').forEach(closeBtn => {
      if (closeBtn.contains(event.target)) {
        const popup = document.querySelector('[js-pdp-popup]');
        if (popup) popup.remove();
      }
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(selectors.productCard).forEach(handleSwatchOverflow);
  });
});

/*
document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener('scroll', function () {
    if (window.scrollY > 40.6) {
      document.querySelector('header .navbar.navigation-primary').classList.add('fixed-top');
      // add padding top to show content behind navbar
    } else {
      document.querySelector('header .navbar.navigation-primary').classList.remove('fixed-top');
      // remove padding top from body
    }
  });
});
*/

/* keep track of previous scroll position - sticky menu scroll up
let prevScrollPos = window.pageYOffset;

window.addEventListener('scroll', function() {
  // current scroll position
  const currentScrollPos = window.pageYOffset;

  if (prevScrollPos > currentScrollPos) {
    // user has scrolled up
    document.querySelector('header .navbar.navigation-primary').classList.add('fixed-top');
    document.querySelector('#topbar').classList.add('fixed-top');
  } else {
    // user has scrolled down
    document.querySelector('header .navbar.navigation-primary').classList.remove('fixed-top');
    document.querySelector('#topbar').classList.remove('fixed-top');
  }

  // update previous scroll position
  prevScrollPos = currentScrollPos;
});*/


let prevScrollPos = window.pageYOffset;

window.addEventListener('scroll', function () {
  const currentScrollPos = window.pageYOffset;
  const navbar = document.querySelector('header .navbar.navigation-primary');
  const topbar = document.querySelector('#topbar');
  const navMob = document.querySelector('#searchMobile');
  const btnSearchMob = document.querySelector('.search-header');

  if (currentScrollPos > 48) {
    navbar.classList.add('fixed-top');
    navMob.classList.add('fixed-top');
    btnSearchMob.classList.add('active');
    if (topbar) topbar.style.display = 'none'; // Oculta la topbar
  } else {
    navbar.classList.remove('fixed-top');
    navMob.classList.remove('fixed-top');
    btnSearchMob.classList.remove('active');
    if (topbar) topbar.style.display = ''; // Muestra la topbar nuevamente
  }

  prevScrollPos = currentScrollPos;
});


// Alerady clicked to the first option of the options
document.addEventListener("DOMContentLoaded", function () {
  const productWrappers = document.querySelectorAll('[js-cus-product-wrapper]')
  productWrappers.forEach((product) => {
    let productOptions = product.querySelectorAll('.color-swatch:not(.hide)')
    productOptions.forEach((option, index) => {
      if (index == 0) {
        option.querySelector('span').click()
      }
    })
  })
})

function UpdateProductAccordion() {
    const customProductFaq = document.querySelector('[js-custom-product-faq]');
    if (customProductFaq) {
        const accordionHeaders = customProductFaq.querySelectorAll('[js-accordion-header]');

        accordionHeaders.forEach((header) => {
          header.addEventListener('click', () => {
            const parent = header.parentElement;
            const content = parent.querySelector('[js-accordion-content]');
            parent.classList.toggle('active');
            if (parent.classList.contains('active')) {
              content.style.maxHeight = content.scrollHeight + 'px';
            } else {
              content.style.maxHeight = 0;
            }
          });
        });
    }
}
UpdateProductAccordion();
document.addEventListener('updateProductAcordion:init', UpdateProductAccordion)

function UpdateSlider() {
  if (window.innerWidth < 990) {
    new Swiper('[js-product-media]', {
      loop: false,
      centeredSlides: true,
      paginationClickable: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}
UpdateSlider();
document.addEventListener('updateSliderEvent:init', UpdateSlider);

function ShippingPopupContent() {
  const shippingBtn = document.querySelector('[js-shipping-btn]');
  if (shippingBtn) {
    const shippingPopup =  document.querySelector('[js-shipping-popup]');
    const closePopup =  document.querySelector('[js-shipping-close]');
    const popupContent =  document.querySelector('[js-popup-inner]');
    shippingBtn.addEventListener('click', ()=> shippingPopup.classList.add('active'))
    closePopup.addEventListener('click', ()=> shippingPopup.classList.remove('active'));
    shippingPopup.addEventListener('click', (evt)=> {
      if (!popupContent.contains(evt.target)) {
        shippingPopup.classList.remove('active');
      }
    });
  }
}
ShippingPopupContent();
document.addEventListener('shippingPopupContent:init',ShippingPopupContent);

function ProductSizeGuide() {
  const productSizeGuideBtn = document.querySelector('[js-product-size-guide]');
  if (productSizeGuideBtn) {
    const productSizeGuide = document.querySelector('[js-size-chart]');
    const productSizeGuideInner = document.querySelector('[js-size-guide-inner]');
    const accordionItem = document.querySelectorAll("[js-tab-item]");
    const tabPannels = document.querySelectorAll("[js-tab-pannel]");
    const crossIcon = document.querySelector("[js-cross-icon]");

    productSizeGuideBtn.addEventListener('click',()=> productSizeGuide.classList.add('is_open'));
    crossIcon.addEventListener('click',()=> productSizeGuide.classList.remove('is_open'));
    productSizeGuide.addEventListener('click', (ev)=> {
      console.log('dskhksdjk')
      if (!productSizeGuideInner.contains(ev.target)) {
        productSizeGuide.classList.remove('is_open');
      }
    })

    if (accordionItem && tabPannels) {
      accordionItem[0].classList.add('active');
      tabPannels[0].classList.add('active');

      accordionItem.forEach((item, index) => {
        item.addEventListener('click', toggleTab);
        function toggleTab() {
          accordionItem.forEach(btn => btn.classList.remove('active'));
          tabPannels.forEach(panel => panel.classList.remove('active'));
          this.classList.add('active');
          tabPannels[index].classList.add('active');
        }
      });
    }
  }
}
ProductSizeGuide();
document.addEventListener('productSizeGuide:init',ProductSizeGuide);

function CuotasPopupContent() {
  const cuotasBtn = document.querySelector('[js-cuotas-btn]');
  if (cuotasBtn) {
    const cuotasPopup =  document.querySelector('[js-cuotas-popup]');
    const closePopup =  document.querySelector('[js-cuotas-close]');
    const popupContent =  document.querySelector('[js-popup-inner]');
    cuotasBtn.addEventListener('click', ()=> cuotasPopup.classList.add('active'))
    closePopup.addEventListener('click', ()=> cuotasPopup.classList.remove('active'));
    cuotasPopup.addEventListener('click', (evt)=> {
      if (!popupContent.contains(evt.target)) {
        cuotasPopup.classList.remove('active');
      }
    });
  }
}
ShippingPopupContent();
document.addEventListener('CuotasPopupContent:init',CuotasPopupContent);


document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 767) return;

  const observer = new MutationObserver(() => {
    document.querySelectorAll('.colorSwatch').forEach(wrapper => {
      const swatch = wrapper.querySelector('.boost-pfs-filter-item-swatch.boost-pfs-filter-item-swatch-color');
      if (!swatch || wrapper.querySelector('.swatch-arrow')) return;

      const leftArrow = document.createElement('button');
      leftArrow.className = 'swatch-arrow left';
      leftArrow.innerHTML = `
      <svg fill="#000000" height="200px" width="200px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <polygon points="332.668,490 82.631,244.996 332.668,0 407.369,76.493 235.402,244.996 407.369,413.507 "></polygon> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </g> </g></svg>`;

      const rightArrow = document.createElement('button');
      rightArrow.className = 'swatch-arrow right';
      rightArrow.innerHTML = `
      <svg fill="#000000" height="200px" width="200px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490 490" xml:space="preserve" transform="rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <polygon points="332.668,490 82.631,244.996 332.668,0 407.369,76.493 235.402,244.996 407.369,413.507 "></polygon> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </g> </g></svg>
    `;

      wrapper.appendChild(leftArrow);
      wrapper.appendChild(rightArrow);

      const updateArrows = () => {
        const scrollLeft = swatch.scrollLeft;
        const maxScrollLeft = swatch.scrollWidth - swatch.clientWidth;

        leftArrow.style.display = scrollLeft <= 0 ? 'none' : 'flex';
        rightArrow.style.display = scrollLeft >= maxScrollLeft - 1 ? 'none' : 'flex';
      };

      updateArrows();

      leftArrow.onclick = () => {
        swatch.scrollLeft -= 80;
        setTimeout(updateArrows, 200);
      };

      rightArrow.onclick = () => {
        swatch.scrollLeft += 80;
        setTimeout(updateArrows, 200);
      };

      swatch.addEventListener('scroll', updateArrows);
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/* Habib

  function moveSortDropdownOnly() {
    if (window.innerWidth > 767) return;

    const realSortBox = document.querySelector('.boost-pfs-filter-toolbar-item.boost-pfs-filter-top-sorting');
    const filterOptionsWrapper = document.querySelector('.boost-pfs-filter-options-wrapper');

    if (!realSortBox || !filterOptionsWrapper) {
      return setTimeout(moveSortDropdownOnly, 500);
    }

    if (document.querySelector('.boost-sort-in-filter')) return;

    const container = document.createElement('div');
    container.className = 'boost-sort-in-filter';

    container.appendChild(realSortBox);
    filterOptionsWrapper.insertBefore(container, filterOptionsWrapper.firstChild);

    filterOptionsWrapper.addEventListener('click', function (e) {
      const clickedInsideSort = e.target.closest('.boost-sort-in-filter');
      if (!clickedInsideSort) {
        container.style.display = 'none';
      }
    });

    container.addEventListener('click', function (e) {
      e.stopPropagation();
      container.style.display = (container.style.display === 'none') ? 'block' : 'block'; 
    });

    const backBtn = document.querySelector('.boost-pfs-filter-back-btn');
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        container.style.display = 'block';
      });
    }
  }

  document.addEventListener("DOMContentLoaded", moveSortDropdownOnly);
  document.addEventListener("boost-pfs-filter-rendered", moveSortDropdownOnly);

*/

function moveSortDropdownOnly() {
  if (window.innerWidth > 767) return;

  const realSortBox = document.querySelector('.boost-pfs-filter-toolbar-item.boost-pfs-filter-top-sorting');
  const filterOptionsWrapper = document.querySelector('.boost-pfs-filter-options-wrapper');

  if (!realSortBox || !filterOptionsWrapper) {
    return setTimeout(moveSortDropdownOnly, 500);
  }

  if (document.querySelector('.boost-sort-in-filter')) return;

  const container = document.createElement('div');
  container.className = 'boost-sort-in-filter';

  container.appendChild(realSortBox);
  filterOptionsWrapper.appendChild(container);

  filterOptionsWrapper.addEventListener('click', function (e) {
    const clickedInsideSort = e.target.closest('.boost-sort-in-filter');
    if (!clickedInsideSort) {
      container.style.display = 'none';
    }
  });

  container.addEventListener('click', function (e) {
    e.stopPropagation();
    container.style.display = 'block'; // puedes eliminar el condicional ya que el resultado es siempre 'block'
  });

  const backBtn = document.querySelector('.boost-pfs-filter-back-btn');
  if (backBtn) {
    backBtn.addEventListener('click', () => {
      container.style.display = 'block';
    });
  }
}

document.addEventListener("DOMContentLoaded", moveSortDropdownOnly);
document.addEventListener("boost-pfs-filter-rendered", moveSortDropdownOnly);


function moveSortDropdownOnlySearch() {
  if (window.innerWidth > 767) return;

  const realSortBox = document.querySelector('.boost-pfs-filter-toolbar-item.boost-pfs-filter-custom-sorting');
  const filterOptionsWrapper = document.querySelector('.boost-pfs-filter-options-wrapper');

  if (!realSortBox || !filterOptionsWrapper) {
    return setTimeout(moveSortDropdownOnlySearch, 500);
  }

  if (document.querySelector('.boost-sort-in-filter')) return;

  const container = document.createElement('div');
  container.className = 'boost-sort-in-filter';

  container.appendChild(realSortBox);
  filterOptionsWrapper.appendChild(container);

  filterOptionsWrapper.addEventListener('click', function (e) {
    const clickedInsideSort = e.target.closest('.boost-sort-in-filter');
    if (!clickedInsideSort) {
      container.style.display = 'none';
    }
  });

  container.addEventListener('click', function (e) {
    e.stopPropagation();
    container.style.display = 'block'; // puedes eliminar el condicional ya que el resultado es siempre 'block'
  });

  const backBtn = document.querySelector('.boost-pfs-filter-back-btn');
  if (backBtn) {
    backBtn.addEventListener('click', () => {
      container.style.display = 'block';
    });
  }
}

document.addEventListener("DOMContentLoaded", moveSortDropdownOnlySearch);
document.addEventListener("boost-pfs-filter-rendered", moveSortDropdownOnlySearch);


// --- formatMoney robusta: garantiza símbolo a la izquierda ---
function formatMoney(cents, format = '$') {
  // Normalizar cents
  if (typeof cents === 'string') {
    // quitar separadores posibles y forzar número
    cents = cents.replace(/\./g, '').replace(/,/g, '');
    cents = parseInt(cents, 10) || 0;
  }

  // Valor en decimales (centavos -> unidad)
  const value = (cents / 100).toFixed(2); // "12300.00"
  const parts = value.split('.');
  const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // "12.300"
  const decimals = parts[1]; // "00"
  //const amount = `${whole},${decimals}`; // "12.300,00"
  const amount = `${whole}`; // "12.300,00"

  // Asegurarnos de que format sea string y contenga 
  if (typeof format !== 'string') format = '$';
  if (format.indexOf('') === -1) format = '$';

  // Separar el format en antes y despues del marcador
  const [beforeRaw, afterRaw] = format.split('');
  const before = beforeRaw ? beforeRaw.trim() : '';
  const after = afterRaw ? afterRaw.trim() : '';

  // Detectar símbolos / códigos de moneda en before/after
  const currencyInBefore = /[$€£¥₡₲฿₹]|[A-Za-z]{1,3}/.test(before);
  const currencyInAfter = /[$€£¥₡₲฿₹]|[A-Za-z]{1,3}/.test(after);

  // Si el símbolo está a la derecha (en after) y no está a la izquierda, moverlo antes
  if (currencyInAfter && !currencyInBefore) {
    // Tomamos sólo el token de moneda que haya en 'after' (ej: "$" o "USD")
    const token = after.match(/[$€£¥₡₲฿₹]|[A-Za-z]{1,3}/);
    const symbol = token ? token[0] : '$';
    return `${symbol}${amount}`.trim();
  }

  // Si ya hay moneda a la izquierda, respetarla (sin espacios extra)
  if (currencyInBefore) {
    return `${before}${amount}`.trim();
  }

  // Si no se detectó moneda en ninguno, usar el format original (reemplazando) y luego asegurarnos de poner $ a la izquierda
  const plain = format.replace('', amount).trim();
  // Si plain acaba con $ al final, moverlo al inicio
  if (plain.endsWith('$')) {
    return ('$' + plain.replace(/\$\s*$/, '')).trim();
  }

  // Fallback por defecto: $ a la izquierda
  return `$${amount}`;
}


//Cerrar sesión en la misma página //
if (!window.logoutCurrentPageInstalled) {
  window.logoutCurrentPageInstalled = true;

  document.addEventListener('click', async function (event) {
    const link = event.target.closest('[data-logout-current-page]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey ||
      event.altKey || event.button !== 0) return;

      const accountPath = new URL(
        null,
        window.location.origin
      ).pathname.replace(/\/$/, '');

          // Dentro de la cuenta, mantener el cierre de sesión normal.
    if (window.location.pathname === accountPath ||
      window.location.pathname.startsWith(accountPath + '/')) {
      return;
  }

  event.preventDefault();
  if (link.dataset.busy === 'true') return;
  link.dataset.busy = 'true';
  link.textContent = 'Cerrando sesión…';
  link.setAttribute('aria-disabled', 'true');
  link.style.cursor = 'wait';

  const currentPage = window.location.href;

  try {
    const response = await fetch(link.href, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) throw new Error('Logout failed');

    window.location.replace(currentPage);
  } catch (error) {
            // Si falla, usar el enlace normal de cierre de sesión.
    window.location.assign(link.href);
  }
});
}
